import React, { useEffect, useRef, useState } from 'react';
import { Filter, selectorWidth } from '@fabric-ui/components';
import FilterInput from '../components/FilterInput';
import { createFreeTextFilter, FreeSearchMatchMode, getFreeTextValue } from './freeSearch.utils';

interface FreeSearchInputProps {
  filter: Filter;
  setFilter: (filter: Filter) => void;
  matchMode?: FreeSearchMatchMode;
  size: 'xSmall' | 'small';
  isVertical: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  autoFocus?: boolean;
}

const FreeSearchInput: React.FC<FreeSearchInputProps> = ({
  filter,
  setFilter,
  matchMode = FreeSearchMatchMode.Exact,
  size,
  isVertical,
  disabled = false,
  readOnly = false,
  autoFocus = false,
}) => {
  const debounceRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const [localValue, setLocalValue] = useState<string | null>(null);

  useEffect(() => () => clearTimeout(debounceRef.current), []);

  const valueFromFilter = getFreeTextValue(filter);
  const inputValue = localValue ?? valueFromFilter;

  return (
    <FilterInput
      size={size}
      readOnly={readOnly}
      disabled={disabled}
      value={inputValue}
      onChange={value => {
        setLocalValue(value);
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
          setFilter(createFreeTextFilter(value, matchMode));
          setLocalValue(null);
        }, 150);
      }}
      placeholder="Type here..."
      inputWidth={isVertical ? selectorWidth : 408}
      sx={{ maxWidth: 'unset' }}
      autoFocus={autoFocus}
      numberField={false}
      operator=""
      options={[]}
    />
  );
};

export default FreeSearchInput;
